var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5" },
        [
          _c(
            "c-table",
            {
              ref: "table1",
              attrs: {
                title: "단위작업 목록",
                columns: _vm.grid1.columns,
                merge: _vm.grid1.merge,
                data: _vm.investigation.sops,
                gridHeight: _vm.gridHeight,
                editable: _vm.editable && _vm.isOld,
                isExcelDown: false,
                filtering: false,
                isFullScreen: false,
                columnSetting: false,
                selection: "multiple",
                rowKey: "heaMuscleSopId",
              },
              on: {
                innerBtnClicked: _vm.innerBtnClicked,
                "table-data-change": _vm.jobtableDataChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "detail"
                        ? [
                            props.row.editFlag !== "C"
                              ? _c(
                                  "q-chip",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "4px !important",
                                    },
                                    attrs: {
                                      outline: "",
                                      square: "",
                                      dense: "",
                                      color: "blue",
                                      clickable: true,
                                      "text-color": "white",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.rowClick(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" ▶ ")]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && _vm.isOld
                        ? _c("c-btn", {
                            attrs: { label: "LBLREMOVE", icon: "delete" },
                            on: { btnClicked: _vm.deleteJob },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.isOld
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addJob },
                          })
                        : _vm._e(),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && _vm.isOld,
                            expression: "editable && isOld",
                          },
                        ],
                        attrs: {
                          isSubmit: _vm.isSaveJob,
                          url: _vm.saveJobUrl,
                          param: _vm.investigation.sops,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveJob,
                          btnCallback: _vm.saveJobCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7" },
        [
          _c(
            "c-table",
            {
              ref: "table2",
              attrs: {
                title: `[${_vm.selectedJob.sopName}] 부담작업 목록`,
                columns: _vm.grid2.columns,
                data: _vm.detailJobs,
                gridHeight: _vm.gridHeight,
                editable: _vm.editable && _vm.isOld,
                isExcelDown: false,
                filtering: false,
                isFullScreen: false,
                columnSetting: false,
                selection: "multiple",
                rowKey: "heaMuscleHeavyWorkId",
              },
              on: { "table-data-change": _vm.tableDataChange },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && _vm.isOld && _vm.isSelect
                        ? _c("c-btn", {
                            attrs: { label: "LBLREMOVE", icon: "delete" },
                            on: { btnClicked: _vm.deleteDetailJob },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.isOld && _vm.isSelect
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addDetailJob },
                          })
                        : _vm._e(),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && _vm.isOld && _vm.isSelect,
                            expression: "editable && isOld && isSelect",
                          },
                        ],
                        attrs: {
                          isSubmit: _vm.isSaveDetailJob,
                          url: _vm.saveDetailJobUrl,
                          param: _vm.detailJobs,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveDetailJob,
                          btnCallback: _vm.saveDetailJobCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }